import { render, staticRenderFns } from "./MyProduct.vue?vue&type=template&id=7dbc32d8"
import script from "./MyProduct.vue?vue&type=script&lang=js"
export * from "./MyProduct.vue?vue&type=script&lang=js"
import style1 from "./MyProduct.vue?vue&type=style&index=1&id=7dbc32d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports